import { useNavigate } from "react-router-dom";
import logoImage from "@/assets/uru-logo-horizontal.jpg?format=webp&w=256";

interface LogoProps {
  to?: string;
}

export const Logo = ({ to = "/" }: LogoProps) => {
  const navigate = useNavigate();

  return (
    <div 
      onClick={() => navigate(to)} 
      className="cursor-pointer relative overflow-hidden h-16 sm:h-20 md:h-20"
      role="button"
      aria-label="Navigate to homepage"
    >
      <img
        src={logoImage}
        alt="UnravelYou"
        width={200}
        height={80}
        loading="eager"
        className="h-full w-auto object-contain object-left hover:opacity-90 transition-opacity duration-200 antialiased"
        style={{
          maxHeight: '80px',
          objectFit: 'contain',
          objectPosition: 'left center'
        }}
      />
    </div>
  );
};
